import { useMemo } from 'react'
import { SimpleShape, SelectionBorder } from '@scene'
import { useTheme } from '@mui/material'
import { ImmutableVector3 } from '@modugen/ui-toolkit'

interface Props {
  points: { x: number; y: number; z: number }[]
}

const FoundationSceneElement = ({ points }: Props) => {
  const { scenePalette } = useTheme()

  const pointsV = useMemo(() => {
    return points?.map(p => new ImmutableVector3(p.x, p.y, p.z))
  }, [points])

  return (
    <group position={[0, 0, 0.01]}>
      <SimpleShape
        points={pointsV}
        noPointerInteractions
        color={scenePalette.selection}
        outlines
        outlinesColor={scenePalette.highlightDark}
        lineWidth={2}
      />
      <SelectionBorder points={pointsV} selected color={scenePalette.selection} />
    </group>
  )
}

export default FoundationSceneElement
